import { FormLabel, InputGroup, InputLeftAddon, Select, useToast } from "@chakra-ui/react";
import { showErrorToast, sortAlphabeticallyByAttribute } from "../../../utils";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useGetAllSupplierCategories } from "../../../hooks/query";
import { FaFilter } from "react-icons/fa";

function FilterSupplierByCategory({ categoryFilter, setCategoryFilter }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierAdminDashboard"
  });
  const toast = useToast();

  const {
    data: categories
  } = useGetAllSupplierCategories({
    onError: err => showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message),
    cacheTime: 0
  });

  return (
    <>
      <FormLabel
        htmlFor={"filterByCategorySelect"}
        opacity="0.75"
        fontSize="xs"
        whiteSpace="nowrap"
        blockSize="5"
        isTruncated
        color="esg_gray.200"
        marginBottom={0}
      >
        {t("filterBySupplierCategory")}
      </FormLabel>
      <InputGroup>
        <InputLeftAddon children={<FaFilter color={categoryFilter !== "" ? "green" : ""} opacity="0.7" />} />
        <Select
          id={"filterByCategorySelect"}
          placeholder={" "}
          backgroundColor="white"
          borderRadius="none"
          value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value)}
          maxInlineSize={{ base: "xs", lg: "250px" }}
          title={categories?.find(el => el.id === categoryFilter)?.name ?? ""}
        >
          {categories
            ?.sort((a, b) => sortAlphabeticallyByAttribute(a, b, "name"))
            ?.map(category => <option key={category?.id} value={category?.id}>{category?.name}</option>) ?? []
          }
        </Select>
      </InputGroup>
    </>
  );
}

export default FilterSupplierByCategory;